// extracted by mini-css-extract-plugin
module.exports = {"load":"load___DqLid"};